module.exports = __webpack_public_path__ + "static/media/magento.8f184c20.svg";